import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import './navbar.css'
import logo from '../../assets/logo.jpeg'
import menu from '../../assets/menu.png'
//import contact from '../../assets/contact.png'

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false)
  const [activeClass, setActiveClass] = useState('main')

  const onClickHandler = (name) => {
    setActiveClass(name)
    setShowMenu(false)
  }

  return (
    <div className="navbar-container">
      <div className="container">
        <nav className="navbar">
          <img src={logo} alt="logo" className="logo" />
          <div className="desktopMenu">
            <Link
              to="/"
              onClick={() => onClickHandler('main')}
              className={
                activeClass === 'main'
                  ? 'desktopMenuListItem active'
                  : 'desktopMenuListItem'
              }
            >
              الرئيسية
            </Link>
            {/* <Link
              activeClass="active"
              to="about-us"
              className="desktopMenuListItem we"
            >
              من نحن
            </Link> */}
            {/* <Link
              to="services"
              className="desktopMenuListItem"
            >
              خدماتنا
            </Link>
            <Link
              to="clients"
              className="desktopMenuListItem"
            >
              عملاؤنا
            </Link>
            <Link
              to="ceo"
              className="desktopMenuListItem"
            >
              كلمة رئيس مجلس الإدارة
            </Link> */}
            <Link
              to="/contact"
              onClick={() => onClickHandler('contact')}
              className={
                activeClass === 'contact'
                  ? 'desktopMenuListItem active'
                  : 'desktopMenuListItem'
              }
            >
              اتصل بنا
            </Link>
          </div>
          {/* <button
            className="desktopMenuBtn"
            onClick={() => {
              document
                .getElementById('contact')
                .scrollIntoView({ behavior: 'smooth' })
            }}
          >
            <img src={contact} alt="" className="desktopMenuImg" />
            إتصل بنا
          </button> */}
          <img
            src={menu}
            alt="menu"
            className="mobMenu"
            onClick={() => setShowMenu(!showMenu)}
          />
          <div
            className="navMenu"
            style={{ display: showMenu ? 'flex' : 'none' }}
          >
            <Link
              to="/"
              onClick={() => onClickHandler('main')}
              className={
                activeClass === 'main' ? 'listItem active' : 'listItem'
              }
            >
              الرئيسية
            </Link>
            {/* <Link
              to="about-us"
              className="listItem"
              onClick={() => setShowMenu(false)}
            >
              من نحن
            </Link>
            <Link
              to="services"
              className="listItem"
              onClick={() => setShowMenu(false)}
            >
              خدماتنا
            </Link>
            <Link
              to="clients"
              className="listItem"
              onClick={() => setShowMenu(false)}
            >
              عملاؤنا
            </Link>
            <Link
              to="ceo"
              className="listItem"
              onClick={() => setShowMenu(false)}
            >
              كلمة رئيس مجلس الإدارة
            </Link> */}
            <Link
              to="/contact"
              onClick={() => onClickHandler('contact')}
              className={
                activeClass === 'contact' ? 'listItem active' : 'listItem'
              }
            >
              اتصل بنا
            </Link>
          </div>
        </nav>
      </div>
    </div>
  )
}
export default Navbar
